import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { UserService } from './user.service';
import { Role } from '../models/role.enum';

export const roleGuard = (allowedRoles: Role[]): CanActivateFn => {
  return () => {
    const auth = inject(AuthService);
    const userService = inject(UserService);
    const router = inject(Router);

    if (!auth.currentUser()) {
      userService.emitUserFromLocalStorage();
    }

    if (auth.hasRole(allowedRoles)) {
      return true;
    }

    return router.parseUrl(auth.homePathForCurrentUser());
  };
};
